import { render, staticRenderFns } from "./TemplateSearch.vue?vue&type=template&id=bb57186a&scoped=true&"
import script from "./TemplateSearch.vue?vue&type=script&lang=js&"
export * from "./TemplateSearch.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSearch.vue?vue&type=style&index=0&id=bb57186a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb57186a",
  null
  
)

export default component.exports